import { unref, ref, watchEffect, Ref, onScopeDispose } from 'vue'

export function useCachedRequest<T, U>(keySource: Ref<U | null>, getter: (key: U) => Promise<T>) {
  const data = ref<T>()
  const isLoading = ref(false)
  const message = ref<string | null>(null)
  const isReady = ref(false)
  const error = ref<boolean | undefined>()

  const cache = new Map<U, T>()

  onScopeDispose(() => {
    cache.clear()
  })

  watchEffect(async () => {
    const key = unref(keySource)
    if (key) {
      isReady.value = false
      isLoading.value = true

      if (cache.has(key)) {
        isReady.value = true
        isLoading.value = false
        data.value = cache.get(key)!
        return
      }

      getter(key)
        .then((newData) => {
          cache.set(key, newData)
          data.value = newData
          isReady.value = true
        })
        .catch((err) => {
          error.value = true
          message.value = err.message
        })
        .finally(() => {
          isLoading.value = false
        })
    }
  })

  return { data, error, isLoading, isReady, message }
}
